import Vue from 'vue';
import Router from 'vue-router';

import Auth from '@/components/auth/Auth';
import ContaAzulAuth from '@/components/auth/ContaAzulAuth';
import Companies from '@/components/companies/Companies';
import CustomerContracts from '@/components/contracts/CustomerContracts';
import CustomerContractPlans from '@/components/contracts/plans/CustomerContractPlans';
import InvoiceBonus from '@/components/customer-bonus/List';
import Customers from '@/components/customers/Customers';
import CustomersExternalCheck from '@/components/customers/CustomersExternalCheck';
import CustomerGroups from '@/components/customers/groups/CustomerGroups';
import ListDiscountAddition from '@/components/discount-addition-services/ListDiscountAddition';
import Discount from '@/components/discount/Discount';
import DiscountApplied from '@/components/discount/DiscountsApplied';
import Home from '@/components/Home';
import GenerateInvoices from '@/components/invoices/GenerateInvoices';
import GenerateSingleInvoice from '@/components/invoices/GenerateSingleInvoice';
import Invoices from '@/components/invoices/Invoices';
import PendingInvoices from '@/components/invoices/pending-invoices/PendingInvoices';
import InvoicesValidations from '@/components/invoices/InvoicesValidations';
import SingleInvoices from '@/components/invoices/SingleInvoices';
import Plans from '@/components/plans/Plans';
import PocHome from '@/components/pocs/Home';
import ReportInvoiceCompany from '@/components/reports/invoice/ReportInvoiceCompany';
import ReportInvoiceCustomer from '@/components/reports/invoice/ReportInvoiceCustomer';
import ReportInvoiceGroup from '@/components/reports/invoice/ReportInvoiceGroup';
import ReportGeneral from '@/components/reports/ReportGeneral';
import Roles from '@/components/users/manager/Roles';
import Scopes from '@/components/users/manager/Scopes';
import Users from '@/components/users/manager/Users';
import NewUser from '@/components/users/NewUser';
import Profile from '@/components/users/Profile';
import CustomerProposals from '@/components/customers/proposals/CustomerProposals';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { name: 'auth', path: '/auth', component: Auth, meta: { public: true } },
    { name: 'home', path: '/', component: Home },
    { name: 'companies', path: '/companies', component: Companies },
    { name: 'invoices', path: '/invoices', component: Invoices },
    { name: 'pending-invoices', path: '/pendinginvoices', component: PendingInvoices },
    { name: 'invoices/generate', path: '/invoices/generate', component: GenerateInvoices },
    { name: 'single-invoices', path: '/singleinvoices', component: SingleInvoices },
    { name: 'invoices/validations', path: '/invoices/validations', component: InvoicesValidations },
    {
      name: 'single-invoice-generate',
      path: '/singleinvoice/generate',
      component: GenerateSingleInvoice,
    },
    {
      name: 'customer-invoice',
      path: '/reports/invoice/customer/:customerId?/:invoiceId?',
      component: ReportInvoiceCustomer,
    },
    {
      name: 'reports/invoice/company',
      path: '/reports/invoice/company/:companyId?/:month?/:year?',
      component: ReportInvoiceCompany,
    },
    {
      name: 'reports/invoice/group',
      path: '/reports/invoice/group/:groupId?/:month?/:year?',
      component: ReportInvoiceGroup,
    },
    { name: 'reports/general', path: '/reports/general/:month?/:year?', component: ReportGeneral },
    { name: 'contaazul-authorized', path: '/contaazul/authorized', component: ContaAzulAuth },
    { name: 'customers', path: '/customers', component: Customers },
    {
      name: 'customers-external',
      path: '/customers/external-check',
      component: CustomersExternalCheck,
    },
    { name: 'customers-contracts', path: '/customers/contracts', component: CustomerContracts },
    { name: 'customers-groups', path: '/customers/groups', component: CustomerGroups },
    {
      name: 'customers-contract-plans',
      path: '/customers/contract/plans',
      component: CustomerContractPlans,
    },
    { name: 'discounts', path: '/discounts', component: Discount },
    { name: 'discount_and_addition_services', path: '/discount_and_addition_services', component: ListDiscountAddition },
    { name: 'discounts-applied', path: '/discounts/applied', component: DiscountApplied },
    { name: 'newuser', path: '/newuser', component: NewUser },
    { name: 'profile', path: '/profile', component: Profile },
    { name: 'users', path: '/users', component: Users },
    { name: 'roles', path: '/users/roles', component: Roles },
    { name: 'scopes', path: '/users/scopes', component: Scopes },
    { name: 'pocs', path: '/customers/pocs', component: PocHome },
    { name: 'proposals', path: '/customers/proposals', component: CustomerProposals },
    { name: 'bonus', path: '/bonus', component: InvoiceBonus },
    { name: 'plans', path: '/plans', component: Plans },
    { path: '*', redirect: '/' },
  ],
});
